import { render, staticRenderFns } from "./splittbale.vue?vue&type=template&id=866e37ea&scoped=true&"
import script from "./splittbale.vue?vue&type=script&lang=js&"
export * from "./splittbale.vue?vue&type=script&lang=js&"
import style0 from "./splittbale.vue?vue&type=style&index=0&id=866e37ea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866e37ea",
  null
  
)

export default component.exports